import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchLaunchLeads } from "../../../services/automapBuyerLaunchApi";
import { LaunchShell } from "./AdminLaunchShared";

export default function AdminLaunchLeadsPage() {
  const [range, setRange] = useState("last_7_days");
  const [unanswered, setUnanswered] = useState(false);
  const [missingAttribution, setMissingAttribution] = useState(false);
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = { range };
    if (unanswered) params.unanswered = "true";
    if (missingAttribution) params.missingAttribution = "true";
    fetchLaunchLeads(params)
      .then((data) => setLeads(data.leads || []))
      .finally(() => setLoading(false));
  }, [range, unanswered, missingAttribution]);

  return (
    <LaunchShell
      active="leads"
      title="Launch lead monitor"
      description="Leads con atribución de campaña."
      viewEvent="launch_lead_monitor_viewed"
    >
      <div className="dealer-inventory-toolbar">
        <select value={range} onChange={(e) => setRange(e.target.value)}>
          <option value="today">Hoy</option>
          <option value="last_7_days">7 días</option>
          <option value="last_30_days">30 días</option>
        </select>
        <label>
          <input type="checkbox" checked={unanswered} onChange={(e) => setUnanswered(e.target.checked)} />
          Sin respuesta
        </label>
        <label>
          <input type="checkbox" checked={missingAttribution} onChange={(e) => setMissingAttribution(e.target.checked)} />
          Sin atribución
        </label>
      </div>
      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {!loading ? (
        <section className="dealer-state-box">
          <table className="dealer-inventory-table">
            <thead>
              <tr>
                <th>Lead</th>
                <th>Dealer</th>
                <th>Campaign</th>
                <th>Landing</th>
                <th>Estado</th>
                <th>Edad (h)</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {leads.map((lead) => (
                <tr key={lead.id}>
                  <td>{lead.buyerName}</td>
                  <td>{lead.dealerName}</td>
                  <td>{lead.campaign}</td>
                  <td>{lead.landingPage || "—"}</td>
                  <td>{lead.dealerResponded ? lead.status : `${lead.status} (pendiente)`}</td>
                  <td>{lead.ageHours}</td>
                  <td>
                    <Link to={`/admin/leads/${lead.id}`}>Ver</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      ) : null}
    </LaunchShell>
  );
}
